import { render, staticRenderFns } from "./DashboardProfitCard.vue?vue&type=template&id=7f79e27e&"
import script from "./DashboardProfitCard.vue?vue&type=script&lang=ts&"
export * from "./DashboardProfitCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports